import { notifications } from "@mantine/notifications";
import classes from "./Notifications.module.css";

export function showSuccess(message: string, title = "Success") {
  notifications.show({
    title: title,
    message: message,
    color: "green.9",
    autoClose: 3000,
    classNames: classes
  });
}
export function showError(message: string, title = "Error") {
  notifications.show({
    title: title,
    message: message,
    color: "red.8",
    autoClose: false,
    withBorder: true,
    classNames: classes
  });
}
